import { apiClient } from '@/services/ApiClient.js'

export class CropPriceIndexService {
  static getCropPriceIndices(query) {
    return apiClient
      .get('crop-price-indices', { params: query })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getCropPriceIndex(cropPriceIndexId) {
    return apiClient
      .get('crop-price-indices/' + cropPriceIndexId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static createCropPriceIndex(params) {
    return apiClient
      .post('crop-price-indices', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static updateCropPriceIndex(CropPriceIndexId, cropPriceIndex) {
    return apiClient
      .patch('crop-price-indices/' + CropPriceIndexId, cropPriceIndex)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static deleteCropPriceIndex(cropPriceIndexId) {
    return apiClient
      .delete('crop-price-indices/' + cropPriceIndexId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
